/* Baby Elephant - Cart Fix (Dawn compatible)
   - Fuerza update por AJAX cuando cambia cantidad
   - Re-render de secciones del carrito
   - Fallback: recarga /cart si algo falla
*/
(() => {
  const isCartPage = window.location.pathname === '/cart';
  if (!isCartPage) return;

  const SECTIONS = ['main-cart-items', 'main-cart-footer'];

  const fetchSections = async () => {
    const url = `${window.location.pathname}?sections=${SECTIONS.join(',')}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Sections fetch failed');
    return await res.json();
  };

  const renderSections = (sectionsJson) => {
    SECTIONS.forEach((id) => {
      const html = sectionsJson[id];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newEl = doc.getElementById(id);
      const curEl = document.getElementById(id);

      if (newEl && curEl) curEl.replaceWith(newEl);
    });
  };

  const changeLineQty = async ({ line, quantity }) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error('Change.js failed');
    return await res.json();
  };

  // Lee "line" desde el input (Dawn suele tener data-index o name="updates[]")
  const getLineFromInput = (input) => {
    const idx = input.getAttribute('data-index') || input.getAttribute('data-cart-item-index');
    if (idx) return Number(idx);

    // Fallback: busca el input dentro del row con atributo data-cart-item o similar
    const row = input.closest('[data-cart-item]') || input.closest('tr') || input.closest('.cart-item');
    const dataLine = row?.getAttribute('data-index') || row?.getAttribute('data-line');
    if (dataLine) return Number(dataLine);

    return null;
  };

  let lock = false;
  const safeUpdate = async ({ input, nextQty }) => {
    if (lock) return;
    lock = true;

    try {
      const line = getLineFromInput(input);
      if (!line) throw new Error('No line found');

      // 1) Cambia qty en Shopify
      await changeLineQty({ line, quantity: nextQty });

      // 2) Re-render secciones
      const sections = await fetchSections();
      renderSections(sections);

      // 3) Dispara evento por si tu barra de envío gratis escucha cambios
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {
      // Fallback duro: recargar carrito
      window.location.reload();
    } finally {
      lock = false;
    }
  };

  // Delegación de eventos
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button');
    if (!btn) return;

    // Dawn: botones suelen tener name="plus" / "minus" o data-action
    const isPlus = btn.name === 'plus' || btn.getAttribute('data-action') === 'increase';
    const isMinus = btn.name === 'minus' || btn.getAttribute('data-action') === 'decrease';

    if (!isPlus && !isMinus) return;

    const input =
      btn.closest('quantity-input')?.querySelector('input[type="number"]') ||
      btn.closest('.quantity')?.querySelector('input[type="number"]') ||
      btn.parentElement?.querySelector('input[type="number"]');

    if (!input) return;

    e.preventDefault();

    const cur = Number(input.value || 0);
    const step = Number(input.step || 1);
    const min = Number(input.min || 0);
    const next = isPlus ? cur + step : Math.max(min, cur - step);

    // actualiza visual inmediato (evita sensación “pegada”)
    input.value = String(next);

    safeUpdate({ input, nextQty: next });
  });

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'number') return;

    // inputs de cantidad
    const inCartQty =
      input.closest('quantity-input') ||
      input.closest('.quantity') ||
      input.name?.includes('updates');

    if (!inCartQty) return;

    const next = Math.max(0, Number(input.value || 0));
    safeUpdate({ input, nextQty: next });
  });
})();
